import axios from "axios";

export const state = {
    checkofflists: [],
};

export const getters = {
    checkofflists: state => state.checkofflists,
};

export const mutations = {
    setCheckoffLists(state, newValue) {
        state.checkofflists = newValue
    },
};

export const actions = {
    async fetchCheckoffLists({ commit }) {
        await axios.get('/checkoff-lists').then(res => {
            commit('setCheckoffLists', res.data.checkofflists);
        })
    },
};
